import React, { memo } from 'react';

import style from './style.module.css';

const BuyerCommentComponent = ({ data }) => <div className={style.host}>{data.bsnClient}</div>;

export const BuyerComment = memo(BuyerCommentComponent);
